<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="standardpage reports invoices border-none">
      <div class="availtable datatable">
        <b-card class="w-100pct">
          <b-card-header class="py-1 mb-2">
            <i :class="options.icon" class="text-primary mr-1"></i>
            {{ item.yourref }}
            <span class="text-warning"
              >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
            >
          </b-card-header>
          <b-card-body class="py-0">
            <b-row>
              <b-col cols="12">
                <b-form-group label="Notes" label-for="notes" label-cols="12">
                  <b-form-textarea
                    id="data"
                    v-model="item.notes"
                    placeholder="Notes"
                    rows="6"
                    class="smalltextarea"
                    :disabled="!permissionvalid('hotels.save')"
                  ></b-form-textarea>
                </b-form-group> </b-col
            ></b-row>
            <b-row style="margin-top: -10px">
              <b-col>
                <b-button
                  squared
                  size="sm"
                  variant="outline-primary"
                  class="mr-1"
                  @click="timestamp"
                >
                  <i class="fa fa-clock-o"></i>
                  Add a timestamp
                </b-button>
              </b-col>
            </b-row>
          </b-card-body>

          <b-card-footer class="mt-2 ml-1">
            <b-row>
              <b-col class="text-left">
                <div v-if="busy">
                  <i class="fa fa-spinner fa-spin text-primary"></i>
                </div>
                <div v-else>
                  <span v-html="message"></span>
                </div>
              </b-col>
              <b-col class="text-right" cols="8">
                <b-button
                  squared
                  size="sm"
                  variant="secondary"
                  class="mr-1"
                  @click="discard"
                >
                  <i class="fa fa-chevron-left pr-1"></i>
                  Back
                </b-button>
                <b-button
                  squared
                  size="sm"
                  variant="primary"
                  @click="saveit()"
                  v-if="user.permissions.includes('hotels.save')"
                >
                  <i class="fa fa-check"></i>
                  Save It
                </b-button>
              </b-col>
            </b-row>
          </b-card-footer>
        </b-card>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "HotelRoomlistsNotes",
  mounted() {
    this.item.agent = this.user.initials;
  },
  data() {
    return {
      busy: false,
      message: "",
      item: {},
      options: {
        title: "Roomlist Note",
        icon: "fa fa-commenting-o",
        debounce: 500,
      },
    };
  },
  computed: {
    readonly() {
      return true;
    },
    // editable() {
    //   if (this.user.rolename == "admin") {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // },
  },
  methods: {
    async load() {
      let variables = {
        id: this.idselected,
      };
      console.log("variables", variables);

      this.busy = true;

      try {
        const response = await this.$apollo.query({
          query: gql`
            query hotels_old($id: String, $dateformat: String) {
              hotels_old(id: $id, dateformat: $dateformat) {
                id
                yourref
                notes
              }
            }
          `,
          variables,
        });

        this.item = response.data.hotels_old[0];

        if (!this.item.notes) {
          this.item.notes = "";
        }
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async timestamp() {
      this.item.notes +=
        "\n" +
        this.$moment().format("DD/MM/YYYY HH:mm:ss") +
        " " +
        this.user.initials +
        "\n";
    },
    async saveit() {
      this.busy = true;

      let variables = {
        rows: [this.cleanit(this.item)],
        dateformat: "DD/MM/YY",
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation hotels_save_old($rows: [Hotel_old_input], $dateformat: String) {
              hotels_save_old(rows: $rows, dateformat: $dateformat) {
                id
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
  },
};
</script>


